import { Component, HostBinding } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PermissionDeliveryOption } from '../../permission/keys/permissionDelivery.interface';
import { UserDataShared } from '../../../models/interface/userData.interface';
import { PermissionService } from '../../permission/permission.service';
import { UserDataService } from '../../../sharedServices/user-data.service';
import { MuComponent } from '../../../types/MuComponent.componetent';
import { ChatFlags } from './chat.flags';
import { Flags } from '../../../types/flags.type';
import { MuChatService } from '../../../sharedServices/mu-chat.service';

@Component({
  selector: 'app-mu-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.sass'],
})
export class MuChatComponent extends MuComponent {
  chatFlags = ChatFlags;
  showWarning = false;
  libraryLoaded = false;
  flags = new Flags<ChatFlags>();

  @HostBinding('class') chatClass = 'mu_chat';

  constructor(private userDataService: UserDataService,
              private permissionService: PermissionService,
              private muChatService: MuChatService) {
    super();
  }

  muOnInit(): void {
    this.prepareChat();
  }

  /**
   * check permission and if it's granted load chat
   * @returns
   */
  async prepareChat() {
    this.libraryLoaded = await this.muChatService.loadFreshChat();
    this.watch(this.userDataService.getUserData()).subscribe(async userData => {
      if (!userData || !userData.id) {
        this.initFreshChat(null);
        return environment.guardClause;
      }
      const removeChat = await this.permissionService.canAccess(PermissionDeliveryOption.DELIVERY_ORDER_REMOVE_CHAT);
      if (removeChat) {
        this.showWarning = false;
        this.muChatService.destroyChat();
        return environment.guardClause;
      }
      this.initFreshChat(userData);
    });
  }

   /**
   * init freshchat
   */
    initFreshChat(userData: UserDataShared) {
      this.showWarning = !this.libraryLoaded;
      if (this.showWarning) {
        return environment.guardClause;
      }
      if (!userData) {
        if ((window as any).fcWidget.isInitialized()) {
          (window as any).fcWidget.user.clear().catch(_ => {
            /** */
          });
          return environment.guardClause;
        }
        this.muChatService.initFreshChatWidget(environment.freshChat);
        return environment.guardClause;
      }
      const userParams = {
        externalId: userData.id,
        firstName: userData.name,
        email: userData.email,
        phone: userData.userPhone,
        companyId: userData.companyId,
      };
      if ((window as any).fcWidget.isInitialized()) {
        (window as any).fcWidget.user.setProperties(userParams);
        return environment.guardClause;
      }
      this.muChatService.initFreshChatWidget({
        ...environment.freshChat,
        ...userParams,
      } as any);
    }

  muOnDestroy(): void {
    this.muChatService.destroyChat();
  }

  /**
   * show the modal
   */
  showAlert() {
    this.flags.enable(ChatFlags.SHOW_WARNING);
  }
}
